// This file is generated by Style Dictionary
const tokens = {
  button: '4px',
  field: '4px',
  accordion: '4px',
  dashboardCard: '4px',
  productCard: '4px',
  menu: '4px',
  timelineCard: '8px',
  banner: '8px',
  fabButton: '32px',
  filterButton: '4px',
  chip: '32px',
};
export default tokens;
